import ItemView from "../../components/ItemView/ItemView.vue"
import { files } from "./attachables";
;
export default [{
    "path": "/UploadedFilesandDocuments",
    "component": { ...ItemView },
    "name": "Uploaded Files and Documents",
    "meta": {
        "app": "ftc",
        "name": "Uploaded Files and Documents",
        "sideNav": true,
        "sideNavSection": "Your Details",
        "tableSettings": "Uploaded Files and Documents",
        "hideBackButton": true,
        title() {
            return `Your Uploaded Files and Documents`;
        },
        "dataFields": [],
        "attachedItems": {
            "Files": {
                "attachables": [files]
            }
        }
    }
}]
